<template lang="pug">
  .ok-cancel-modal
    b-modal(v-model="_value" :size="size" hide-header @ok="ok" @cancel="cancel" no-close-on-backdrop no-close-on-esc)
      .default-modal-body
        .default-modal-title {{ title }}
        .default-modal-message(v-if="message").mt-2 {{ message }}
        .d-flex.flex-column(v-if="_showCheckbox == true")
          span.warning-message.mt-2(style="font-size: 16px;") 家族全員へのメッセージで良いでしょうか？
          b-form-checkbox(v-model="_checked" style="font-size: 16px;") 確認しました

      template(#modal-footer="{ ok, cancel }")
        b-button.btn.modal-ok-btn(:class="{ 'disable': !checked }" :disabled="!checked" @click="ok") {{ okButtonLabel }}
        b-button.btn.modal-cancel-btn(@click="cancel") {{ cancelButtonLabel }}
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

/**
 * ### チェックボックス付き、OK/キャンセルモーダル
 */
@Component
export default class CheckOkCancelModal extends Vue {
  /** 表示可否 */
  @Prop({ required: true })
  value!: boolean;
  /** タイトル */
  @Prop({ required: true })
  title!: string;
  /** メッセージ */
  @Prop()
  message!: string;
  /** モーダルサイズ */
  @Prop({ default: () => "md" })
  size!: string;
  /** OKボタンラベル */
  @Prop({ default: () => "OK" })
  okButtonLabel!: string;
  /** キャンセルボタンラベル */
  @Prop({ default: () => "キャンセル" })
  cancelButtonLabel!: string;

  /** 家族全員へのメッセージで良いでしょうか？のチェックボックスを表示するか否か */
  @Prop()
  showCheckbox!: boolean;
  /** 家族全員へのメッセージで良いでしょうか？のチェックボックスのチェック */
  @Prop()
  checked!: boolean;

  get _value(): boolean {
    return this.value;
  }

  set _value(newValue: boolean) {
    this.$emit("input", newValue);
    return;
  }

  get _showCheckbox(): boolean {
    return this.showCheckbox;
  }

  set _showCheckbox(newValue: boolean) {
    this.$emit("update:showCheckbox", newValue);
    return;
  }

  get _checked(): boolean {
    return this.checked;
  }

  set _checked(newValue: boolean) {
    this.$emit("update:checked", newValue);
    return;
  }

  public ok(): void {
    this.$emit("ok");
    return;
  }

  public cancel(): void {
    this.$emit("cancel");
    return;
  }
}
</script>
